module.exports = __webpack_public_path__ + "img/research_pic.a678e650.png";